package com.nonopn.skywatcher.common.app.pages.map.view.map

import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.pages.map.model.UserDidntValidateTheAlert
import com.nonopn.skywatcher.common.app.pages.map.model.UserValidatedTheAlert
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.user_legend_alert
import com.nonopn.skywatcher.common.app.res.user_legend_alert_not_validated
import com.nonopn.skywatcher.common.app.res.user_legend_alert_validated
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.utils.localized
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.TextNormal

@Composable
fun UserAlertLegend(
    modifier: Modifier
) {
    MapOverlayCard(modifier) {
        Column(
            modifier = Modifier.padding(8.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            TextNormal(
                text = Res.string.user_legend_alert.localized(),
                fontSize = LocalFontSizes.current.map.activityLightning
            )

            Row(
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Column(
                    Modifier.clip(RoundedCornerShape(50))
                        .background(UserValidatedTheAlert)
                ) {
                    TextNormal(
                        modifier = Modifier.padding(8.dp),
                        text = Res.string.user_legend_alert_validated.localized(),
                        color = AppColor.GrayExtraDark,
                        fontSize = LocalFontSizes.current.map.activityLightning
                    )
                }
                Column(
                    Modifier.clip(RoundedCornerShape(50))
                        .background(UserDidntValidateTheAlert)
                ) {
                    TextNormal(
                        modifier = Modifier.padding(8.dp),
                        text = Res.string.user_legend_alert_not_validated.localized(),
                        fontSize = LocalFontSizes.current.map.activityLightning
                    )
                }
            }
        }
    }
}

@Composable
@HotPreview(widthDp = 600, heightDp = 400, darkMode = true)
@HotPreview(widthDp = 600, heightDp = 400, darkMode = false)
private fun Preview() {
    HotPreviewApp(
        Modifier.fillMaxSize().padding(10.dp),
        isDarkTheme = isSystemInDarkTheme()
    ) {
        UserAlertLegend(
            Modifier.fillMaxSize()
        )
    }
}